/* @flow */

export const REDUX_TYPE_SET_LANGUAGE: 'REDUX_TYPE_SET_LANGUAGE' = 'REDUX_TYPE_SET_LANGUAGE';
export const REDUX_TYPE_SET_VERSION: 'REDUX_TYPE_SET_VERSION' = 'REDUX_TYPE_SET_VERSION';
